import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Box, useMultiStyleConfig} from '@chakra-ui/react'
import ProductTile from '../../../components/product-tile'
import {CompareProvider} from '../../../context/compare'
import NewsletterBanner from '../../../components/newsletter-banner'
import {remCalc} from '../../../theme/_utils'

const SurveyResults = ({retrievedProducts, surveyAnswers}) => {
    const styles = useMultiStyleConfig('HelpMeChoose')

    return (
        <Flex {...styles.resultsInnerContainer} flexDirection="column">
            <CompareProvider>
                <Flex
                    {...styles.retrievedProductsContainer}
                    display={{base: 'grid', lg: 'flex'}}
                    flexDirection={{base: 'column', lg: 'row'}}
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                >
                    {retrievedProducts?.map((product, i) => {
                        return i < 3 ? (
                            <Box
                                key={product.id}
                                width={{
                                    base: '100%',
                                    lg: retrievedProducts.length >= 3 ? '30%' : remCalc(361),
                                }}
                                flexShrink={0}
                            >
                                <ProductTile
                                    key={product.id}
                                    data-testid={`survey-product-tile ${product.id}`}
                                    enableFavourite
                                    isFavourite={false}
                                    product={product}
                                    productIndex={i}
                                    dynamicImageProps={styles?.retrievedProductsImageProps}
                                    shouldHideCompare
                                    shouldHideReviews
                                    shouldHideVariants
                                />
                            </Box>
                        ) : (
                            <></>
                        )
                    })}
                </Flex>
            </CompareProvider>
            <NewsletterBanner
                id="product-registration-newsletter"
                surveyAnswers={surveyAnswers}
                retrievedProducts={retrievedProducts}
            />
        </Flex>
    )
}

SurveyResults.propTypes = {
    retrievedProducts: PropTypes.array,
    surveyAnswers: PropTypes.object,
}
export default SurveyResults
